import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import NumericLabel from "react-pretty-numbers";
import { Pie } from 'react-chartjs-2';
import ActionButton from "../common/button/actionbutton.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
import LocationSelect from "../location/locationselect.component.jsx";
import Icon from "../common/icon/icon.component.jsx";

let labelsMap = {
    'too-expensive': "#5bc0de",
    'bought-somewhere-else': "#f0ad4e",
    'not-interested': "#5cb85c",
    'not-ready-to-buy': "#0275d8",
    'too-long-delivery-time': "#f7f7f7",
    'expired': "#6c757d",

}

const options = {
    maintainAspectRatio: false,
    responsive: true,
    title: 'Lost Reasons',
    legend: {
        position: 'bottom',
        pieSliceText: 'label',
        labels: {
            boxWidth: 10,
            padding: 20,
            fontSize: 18,
        },
    },
    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                let dataset = data.datasets[tooltipItem.datasetIndex];
                let total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                    return parseFloat(previousValue) + parseFloat(currentValue);
                });
                let currentValue = parseFloat(dataset.data[tooltipItem.index]);
                let percentage = ((currentValue / total) * 100).toFixed(2);
                return currentValue + " (" + percentage + "%)";
            }
        }
    }


}

const messages = defineMessages({
    monthly_report_what_else_question_placeholder: {
        id: 'monthly.report.what_else_question_placeholder',
        defaultMessage: 'E.g. conversion rate of other merchants in your industry',
    },
    monthly_report_what_else_question: {
        id: 'monthly.report.what_else_question',
        defaultMessage: 'What other information you would like to see in the monthly report?',
    },
    monthly_report_why_question_placeholder: {
        id: 'monthly.report.why_question_placeholder',
        defaultMessage: 'A few words to describe why you need it',
    },
    monthly_report_why_question: {
        id: 'monthly.report.why_question',
        defaultMessage: 'Why?',
    },
    monthly_report_submit_btn: {
        id: 'monthly.report.submit_form_btn',
        defaultMessage: 'Submit',
    },
    monthly_report_pichart_label: {
        id: 'monthly.report.piechart_label',
        defaultMessage: 'Lost Reasons',
    },
    monthly_report_title: {
        id: 'monthly.report.title',
        defaultMessage: 'Sales report',
    },

    January: {
        id: 'monthly.report.january',
        defaultMessage: 'January',
    },
    February: {
        id: 'monthly.report.february',
        defaultMessage: 'February',
    },
    March: {
        id: 'monthly.report.march',
        defaultMessage: 'March',
    },
    April: {
        id: 'monthly.report.april',
        defaultMessage: 'April',
    },
    May: {
        id: 'monthly.report.may',
        defaultMessage: 'May',
    },
    June: {
        id: 'monthly.report.june',
        defaultMessage: 'June',
    },
    July: {
        id: 'monthly.report.july',
        defaultMessage: 'July',
    },
    August: {
        id: 'monthly.report.august',
        defaultMessage: 'August',
    },
    September: {
        id: 'monthly.report.september',
        defaultMessage: 'September',
    },
    October: {
        id: 'monthly.report.october',
        defaultMessage: 'October',
    },
    November: {
        id: 'monthly.report.november',
        defaultMessage: 'November',
    },
    December: {
        id: 'monthly.report.december',
        defaultMessage: 'December',
    },

    'too-expensive': {
        id: 'monthly.report.too_expensive',
        defaultMessage: 'Too expensive ({number})',
    },
    'bought-somewhere-else': {
        id: 'monthly.report.bought_somewhere_else',
        defaultMessage: 'Customer bought somewhere else ({number})',
    },
    'not-interested': {
        id: 'monthly.report.not_interested',
        defaultMessage: 'Not interested by the products ({number})',
    },
    'not-ready-to-buy': {
        id: 'monthly.report.not_ready_to_buy',
        defaultMessage: 'Customer not ready to buy ({number})',
    },
    'too-long-delivery-time': {
        id: 'monthly.report.too_long_delivery_time',
        defaultMessage: 'Too long delivery time ({number})',
    },
    'expired': {
        id: 'monthly.report.expired',
        defaultMessage: 'Expired ({number})',
    },
    'prev_month': {
        id: 'monthly.report.prev_month',
        defaultMessage: 'prev. month',
    },

})

let months = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"]


function findDiffPercentage(thisMonthValue, diffValue, reverse = false) {
    if (thisMonthValue - diffValue === 0) {
        return String("n/a")
    } else {
        let diff = reverse ? Math.abs(diffValue / (thisMonthValue - diffValue)) : (diffValue / (thisMonthValue - diffValue))
        return String(diff.toFixed(2))
    }
}

function findLastMonthValue(thisMonthValue, diffValue, numberOfDecimals = 2) {
    return String((thisMonthValue - diffValue).toFixed(numberOfDecimals))
}

class QuoteMonthlyReportEmbed extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            datasets: [{
                data: [],
                backgroundColor: []
            }],
            year: this.props.match.params.year,
            month: this.props.match.params.month,
            lostReasons: {},
            avgDaysToClose: 0,
            companyLogoId: '',
            companyName: '',
            conversionRate: 0,
            quoteDeclinedUpdatedOffer: 0,
            quoteSent: 0,
            quoteWon: 0,
            totalAmountWon: 0,
            avgDaysToCloseDiff: 0,
            conversionRateDiff: 0,
            quoteSentDiff: 0,
            quoteWonDiff: 0,
            totalAmountWonDiff: 0,
            monthlyReportWhatElseQuestion: '',
            monthlyReportWhyQuestion: '',
            submitFeedBackForm: false,
            submitFeedBackFormLoading: false,
            labelsMap: labelsMap,
            locationId: '',
            options,
        }
        this.year = this.props.match.params.year
        this.month = this.props.match.params.month
        this.submit = this.submit.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.changeValue = this.changeValue.bind(this)
        this.requestReport = this.requestReport.bind(this)
    }

    requestReport() {
        AppContext.getApiClient().post('/reports/quote-monthly-report', {
            "year": this.state.year,
            "month": this.state.month,
            "locationId": this.state.locationId,
        }).then(r => {
            this.setState({
                companyLogoId: r.attributes.quoteStats.attributes.companyLogoId,
                companyName: r.attributes.quoteStats.attributes.companyName,
                conversionRate: r.attributes.quoteStats.attributes.conversionRate,
                quoteSent: r.attributes.quoteStats.attributes.quoteSent,
                quoteWon: r.attributes.quoteStats.attributes.quoteWon,
                totalAmountWon: r.attributes.quoteStats.attributes.totalAmountWon,
                totalAmountWonDiff: r.attributes.totalAmountWonDiff,
                avgDaysToClose: r.attributes.quoteStats.attributes.avgDaysToClose,
                lostReasons: r.attributes.quoteStats.attributes.lostReasons,
                avgDaysToCloseDiff: r.attributes.avgDaysToCloseDiff,
                conversionRateDiff: r.attributes.conversionRateDiff,
                quoteSentDiff: r.attributes.quoteSentDiff,
                quoteWonDiff: r.attributes.quoteWonDiff,
                monthlyReportWhatElseQuestion: this.state.monthlyReportWhatElseQuestion,
                monthlyReportWhyQuestion: this.state.monthlyReportWhyQuestion,
            })
        })

    }

    submit(event) {
        event.preventDefault()
        AppContext.getApiClient().post('/reports/quote-monthly-report-feedback', {
            "question": this.state.monthlyReportWhatElseQuestion,
            "answer": this.state.monthlyReportWhyQuestion,
        }).then(q => {
            this.setState({
                submitFeedBackForm: true,
                submitFeedBackFormLoading: false,
            })
        })
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        }, () => {
            this.changeValue()
        })
    }

    changeValue() {
        const onChange = this.props.onChange || function () {
        }
        onChange({
            monthlyReportWhatElseQuestion: this.state.monthlyReportWhatElseQuestion,
            monthlyReportWhyQuestion: this.state.monthlyReportWhyQuestion,
        })
    }

    componentDidMount() {
        document.querySelector("body").setAttribute('style', '')
        this.requestReport()
        if (GlobalHelper.getResponsiveBreakpoint() == "xs") {
            let options = Object.assign({}, this.state.options)
            options.legend.position = 'bottom'
            this.setState({
                options,
            })
        }
    }

    getClassColor(diff, reverse = false) {
        diff = parseFloat(diff)
        diff = reverse ? Math.abs(diff) : diff
        if (diff === 0) {
            return ''
        } else if ( diff > 0 ) {
            return 'text-success'
        } else {
            return 'text-danger'
        }
    }

    getCaretClass(diff, reverse = false) {
        diff = parseFloat(diff)
        diff = reverse ? Math.abs(diff) : diff
        if (diff === 0) {
            return ''
        } else if (diff > 0 ) {
            return 'fa text-success fa-caret-up'
        } else {
            return 'fa text-danger fa-caret-down'
        }
    }

    render() {
        let numberLabel = {
            justification: 'L',
            locales: AppContext.getLocale().getLanguage(),
            currency: true,
            currencyIndicator: AppContext.getCurrency(),
            percentage: false,
            precision: 0,
            commafy: false,
            shortFormat: true,
            title: true,
        }
        let data = [];

        {/* We want to display the name of the month in the report as the names of the months are stored in an array we have to do month -1 */
        }
        let month = this.props.intl.formatMessage(messages[months[this.state.month - 1]])
        let keys = Object.keys(this.state.lostReasons)
        let values = Object.values(this.state.lostReasons)
        let reason;
        let colorList = [];
        let LabelFormatted = [];
        for (reason of keys) {
            colorList.push(labelsMap[reason])
            LabelFormatted.push(this.props.intl.formatMessage(messages[reason], {number: this.state.lostReasons[reason]}))
        }
        return (
            <div id="QuoteMonthlyReportEmbed" className="container mt-2 mb-4">
                {/* Company Name  + Month  + Year */}
                <div className="row m-0">
                    <div className="col-12 col-md-9 bg-secondary py-2">
                        <h3 className="m-0 p-0 justify-content-start text-white">
                            {this.state.companyName} - {this.props.intl.formatMessage(messages["monthly_report_title"])}
                        </h3>
                    </div>
                    <div className="col-12 col-md-3 pr-0 d-flex align-items-center justify-content-end mt-2 mt-md-0">
                        <h4 className="m-0 p-0 justify-content-end d-flex">{month} {this.state.year}</h4>
                    </div>
                </div>

                <div className="row m-0 mt-3 mb-3 p-0">
                    {/* Locations */}
                    <div
                        className="col-12 col-md-3 mr-0 pl-0 pr-0 d-flex justify-content-start flex-column align-items-start">
                        {GlobalHelper.canEditLocation() ?
                            <div className="mb-3 w-100" key={"2"}>
                                <LocationSelect
                                    optionForAll={true}
                                    valueForAll={''}
                                    value={this.state.locationId}
                                    onChange={locationId => {
                                        this.setState({ locationId: locationId }, this.requestReport)
                                    }}
                                    className="form-control"
                                />
                            </div> : ''}
                    </div>

                </div>
                {/* Quote Won  +  Quote Amount Won*/}
                <div className="row">
                    {/* Quote Won */}
                    <div className="col-lg-6">
                        <div className="dashboard-stats-box p-3">
                            <div className="dashboard-stat-value pt-0">
                                <div className="row">
                                    <div className="col-lg-6 justify-content-start">
                                        <h1 className="display-4 custom-lead text-custom-secondary strong text-break">
                                            <FormattedNumber
                                                value={this.state.quoteWon}
                                            />
                                        </h1>
                                        <h6 className='text-secondary strong'>
                                            <FormattedMessage
                                                id="monthly.report.quote_won"
                                                defaultMessage="Quote Won"
                                            />
                                        </h6>
                                    </div>
                                    {findDiffPercentage(this.state.quoteWon, this.state.quoteWonDiff) !== "n/a" ?
                                        <div className="col-lg-6 justify-content-start">
                                            <div>
                                                <h1 className="mr-2 d-inline display-4 custom-lead text-custom-primary text-break">
                                                    <i className={this.getCaretClass(this.state.quoteWonDiff)} />
                                                </h1>
                                                <h1 className={'d-inline display-4 custom-lead ' + this.getClassColor(this.state.quoteWonDiff)}>
                                                    <FormattedNumber style={'percent'}
                                                        value={findDiffPercentage(this.state.quoteWon, this.state.quoteWonDiff)}
                                                    />
                                                </h1>
                                            </div>
                                            <h6 className='text-secondary strong'>
                                                {"vs "}<strong className="h5">{findLastMonthValue(this.state.quoteWon, this.state.quoteWonDiff, 0)} </strong> {this.props.intl.formatMessage(messages["prev_month"])}
                                            </h6>
                                        </div>
                                        : ''}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quote Amount Won */}
                    <div className="col-lg-6 mt-4 mt-lg-0">
                        <div className="dashboard-stats-box p-3">
                            <div className="dashboard-stat-value pt-0">
                                <div className="row">
                                    <div className="col-lg-6 justify-content-start">
                                        <h1 className="display-4 custom-lead text-custom-secondary strong text-break">
                                            <NumericLabel params={numberLabel}>
                                                {this.state.totalAmountWon}
                                            </NumericLabel>
                                        </h1>
                                        <h6 className='text-secondary strong'>
                                            <FormattedMessage
                                                id="monthly.report.quote_amount_won"
                                                defaultMessage="Quote amount won"
                                            />
                                        </h6>
                                    </div>
                                    {findDiffPercentage(this.state.totalAmountWon, this.state.totalAmountWonDiff) !== "n/a" ?
                                        <div className="col-lg-6 justify-content-start">
                                            <div>
                                                <h1 className="mr-2 d-inline display-4 custom-lead text-custom-primary text-break">
                                                    <i className={this.getCaretClass(this.state.totalAmountWonDiff)} />
                                                </h1>
                                                <h1 className={'d-inline display-4 custom-lead text-custom-primary text-break ' + this.getClassColor(findDiffPercentage(this.state.totalAmountWon, this.state.totalAmountWonDiff))}>
                                                    <FormattedNumber style={'percent'}
                                                        value={findDiffPercentage(this.state.totalAmountWon, this.state.totalAmountWonDiff)}
                                                    />
                                                </h1>
                                            </div>
                                            <h6 className={'text-secondary strong'}>
                                                {"vs  "}<strong className="h5"><NumericLabel
                                                    params={numberLabel}>{findLastMonthValue(this.state.totalAmountWon, this.state.totalAmountWonDiff, 2)}</NumericLabel></strong> {this.props.intl.formatMessage(messages["prev_month"])}
                                            </h6>
                                        </div>
                                        : ''}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4" />

                    {/* Conversion Rate */}
                    <div className="col-lg-6 mt-4">
                        <div className="dashboard-stats-box p-3">
                            <div className="dashboard-stat-value pt-0">
                                <div className="row">
                                    <div className="col-lg-6 justify-content-start">
                                        <h1 className="display-4 custom-lead text-custom-secondary strong text-break">
                                            <FormattedNumber
                                                value={this.state.conversionRate}
                                                style="percent"
                                            />
                                        </h1>
                                        <h6 className='text-secondary strong'>
                                            <FormattedMessage
                                                id="monthly.report.conversion_rate"
                                                defaultMessage="Conversion Rate"
                                            />
                                        </h6>
                                    </div>
                                    {findDiffPercentage(this.state.conversionRate, this.state.conversionRateDiff) !== "n/a" ?
                                        <div className="col-lg-6 justify-content-start">
                                            <div>
                                                <h1 className="mr-2 d-inline display-4 custom-lead text-custom-primary text-break">
                                                    <i className={this.getCaretClass(this.state.conversionRateDiff)} />
                                                </h1>
                                                <h1 className={'d-inline display-4 custom-lead ' + this.getClassColor(this.state.conversionRateDiff)}>
                                                    <FormattedNumber style={'percent'}
                                                        value={findDiffPercentage(this.state.conversionRate, this.state.conversionRateDiff)}
                                                    />
                                                </h1>
                                            </div>
                                            <h6 className='text-secondary strong'>
                                                {"vs "}<strong className="h5">
                                                <FormattedNumber
                                                    value={findLastMonthValue(this.state.conversionRate, this.state.conversionRateDiff, 2)}
                                                    style="percent"
                                                />
                                                &nbsp;
                                                </strong>{this.props.intl.formatMessage(messages["prev_month"])}
                                            </h6>
                                        </div>
                                        : ''}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Average days to Close */}
                    <div className="col-lg-6 mt-4">
                        <div className="dashboard-stats-box p-3">
                            <div className="dashboard-stat-value pt-0">
                                <div className="row">
                                    <div className="col-lg-6 justify-content-start">
                                        <h1 className="display-4 custom-lead text-custom-secondary strong text-break">
                                            <FormattedNumber
                                                value={parseFloat(this.state.avgDaysToClose).toFixed(2)}
                                            />
                                        </h1>
                                        <h6 className='text-secondary strong'>
                                            <FormattedMessage
                                                id="monthly.report.avg_days_close_quote"
                                                defaultMessage="Avg Days to Close a Quote"
                                            />
                                        </h6>
                                    </div>
                                    {findDiffPercentage(this.state.avgDaysToClose, this.state.avgDaysToCloseDiff) !== "n/a" ?
                                        <div className="col-lg-6 justify-content-start">
                                            <div>
                                                <h1 className="mr-2 d-inline display-4 custom-lead text-custom-primary text-break">
                                                    <i className={this.getCaretClass(this.state.avgDaysToCloseDiff, true)} />
                                                </h1>
                                                <h1 className={'d-inline display-4 custom-lead ' + this.getClassColor(this.state.avgDaysToCloseDiff, true)}>
                                                    <FormattedNumber style={'percent'}
                                                        value={findDiffPercentage(this.state.avgDaysToClose, this.state.avgDaysToCloseDiff, true)}
                                                    />
                                                </h1>
                                            </div>
                                            <h6 className='text-secondary strong'>
                                                {"vs "}<strong className="h5">{findLastMonthValue(this.state.avgDaysToClose, this.state.avgDaysToCloseDiff, 2)} </strong>{this.props.intl.formatMessage(messages["prev_month"])}
                                            </h6>
                                        </div>
                                        : ''}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* Pie Chart + Label */}
                {keys.length > 0 ? <div className={' dashboard-stats-box col-12 col-lg-8 mt-4'}>
                    <h5 className="text-secondary w-100 strong">
                        <FormattedMessage
                            id="monthly.report.piechart_label"
                            defaultMessage="Lost Reasons"
                        />
                    </h5>
                    <div
                        className="mb-4"
                        key={"2"}>
                        <Pie
                            options={this.state.options}
                            animation
                            animationDuration={500}
                            animationEasing="ease-out"
                            lengthAngle={360}
                            lineWidth={15}
                            paddingAngle={0}
                            rounded
                            startAngle={0}
                            height={500}
                            width={500}
                            label={true}
                            data={{
                                labels: LabelFormatted,
                                datasets: [{
                                    data: values,
                                    backgroundColor: colorList
                                }],
                            }}
                            labelStyle={{
                                fontSize: "10px",
                                fontColor: "FFFFFA",
                                fontWeight: "800",
                            }}
                        />
                    </div>
                </div> : ''}
                {/* Submit Form */}
                <hr className="my-4 my-md-5"/>
                <div className="container mt-2">
                    <div className="row">
                        <div className="col-12 col-lg-8 offset-lg-2 div-wrapper d-flex justify-content-center align-items-center d-flex align-items-start">
                            <div className={'display-4 px-4 align-self-start'}>
                                <Icon value={'comments'} />
                            </div>
                            <div>
                                <h3 className="text-secondary w-100 strong custom-lead">
                                    <FormattedMessage
                                        id="monthly.report.give_us_feedback_title"
                                        defaultMessage="Give us feedback to improve your report!"
                                    />
                                </h3>
                                <form>
                                    <div className="form-group ">
                                        <label> {this.props.intl.formatMessage(messages["monthly_report_what_else_question"])}</label>
                                        <input disabled={this.state.submitFeedBackForm} className="form-control"
                                            name="monthlyReportWhatElseQuestion"
                                            value={this.state.monthlyReportWhatElseQuestion}
                                            onChange={this.handleFormChange}
                                            id="monthlyReportWhatElseQuestion"
                                            placeholder={this.props.intl.formatMessage(messages["monthly_report_what_else_question_placeholder"])} />

                                    </div>
                                    <div className="form-group">
                                        <label> {this.props.intl.formatMessage(messages["monthly_report_why_question"])}</label>
                                        <textarea disabled={this.state.submitFeedBackForm} className="form-control"
                                            name="monthlyReportWhyQuestion"
                                            value={this.state.monthlyReportWhyQuestion}
                                            onChange={this.handleFormChange}
                                            id="monthlyReportWhyQuestion"
                                            rows="3"
                                            placeholder={this.props.intl.formatMessage(messages["monthly_report_why_question_placeholder"])} />
                                    </div>
                                    {this.state.submitFeedBackForm ?
                                        <div className="alert alert-success " role="alert">
                                            Thanks for your feedback. Your feedback was sent successfully!
                                        </div> : ''}
                                    <div className="form-group text-right">
                                        <ActionButton className="btn btn-primary ml-2"
                                            onClick={this.submit}
                                            disabled={this.state.monthlyReportWhyQuestion.length === 0 || this.state.monthlyReportWhatElseQuestion.length === 0 || this.state.submitFeedBackForm}
                                            isLoading={this.state.submitFeedBackFormLoading}>
                                            {this.props.intl.formatMessage(messages["monthly_report_submit_btn"])}
                                        </ActionButton>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default injectIntl(QuoteMonthlyReportEmbed)



// WEBPACK FOOTER //
// ./src/report/quotemonthlyreport.component.jsx